export default {
    navigationBarTitleText: '全景案例'
};